import axios from 'axios';

export async function guardarEmpresaConfig(data) {
  const formData = new FormData();
  for (const key in data) {
    if (data[key] !== undefined && data[key] !== null) {
      formData.append(key, data[key]);
    }
  }
  return axios.post('/api/empresa-config', formData);
}

export async function obtenerEmpresaConfig() {
  const { data } = await axios.get('/api/empresa-config');
  return data;
}

// Sin autenticación — usado en el login y para el favicon antes de iniciar sesión.
export async function obtenerLogoPublico() {
  const { data } = await axios.get('/api/public/empresa/logo');
  return data;
}
